import { Container } from 'react-bootstrap';

const SubHeader = () => {
  return (
    <div style={{ backgroundColor: '#f8f9fa', padding: '10px 0' }}>
      <Container className="text-center">
        <strong>Our service is currently limited to Hyderabad. We strive to deliver your order within 6 - 24 hours</strong>
      </Container>
    </div>
  );
};

export default SubHeader;